module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13067ea7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/SetAuthKey.vue
// module id = 720
// module chunks = 0